import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Header from './Header';

import { logout } from '../../../actions/auth-actions';
import { hasOnlyGEMReportPage } from '../../../reducers/user-reducer';

import './Header.css';
import './Header.print.css';

const mapStateToProps = ({ auth, user }) => ({
  clientAvatar: user.avatar,
  loggedIn: auth.loggedIn,
  onlyGEMReport: hasOnlyGEMReportPage({ user }),
  user
});
const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
